import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

import { makeChildren } from '../utils';

export const MONITORING_TABS = [
  'recap',
  'providers',
  'mailers',
  'orders_sepa',
  'orders_processing',
  'invoices',
  'netstorming',
  'orders_sync',
  'failed_transits',
  'membership_assignment_status',
  'membership_blocked',
  'membership_unpaid',
  'trenord_loyalty',
] as const;

export const CHALLENGE_TABS = [
  'info',
  'config',
  'goals',
  'sponsors',
  'prizes',
  'participants',
] as const;

export type MonitoringTabs = (typeof MONITORING_TABS)[number];

export type ChallengeTabs = (typeof CHALLENGE_TABS)[number];

export const GraphPath: MainPath = '/graphs';
export const LookerStudioPath: MainPath = '/looker';
export const MonitoringPath: MainPath = '/monitoring/:section?';
export const TaskAIPath: MainPath = '/task_ai';

export const GraphRoute: MainNavRoute = {
  path: '/graphs',
  label: 'routes.graphs',
  icon: 'chart_pie',
  type: 0,
};

export const LookerStudioRoute: MainNavRoute = {
  path: '/looker',
  label: 'routes.looker_studio',
  icon: 'google_locker',
  type: 1,
  permissions: [PERMISSIONS.PARTNERS__LOOKER_STUDIO],
};

export const MonitoringRoute: MainNavRoute = {
  path: '/monitoring',
  label: 'routes.monitoring',
  icon: 'chart_mixed',
  type: 0,
  children: makeChildren<MonitoringTabs>({
    recap: { path: 'recap' },
    invoices: { path: 'invoices' },
    mailers: { path: 'mailers' },
    netstorming: { path: 'netstorming' },
    orders_processing: { path: 'orders_processing' },
    orders_sepa: { path: 'orders_sepa' },
    orders_sync: { path: 'orders_sync' },
    providers: { path: 'providers' },
    failed_transits: { path: 'failed_transits' },
    membership_assignment_status: { path: 'membership_assignment_status' },
    membership_blocked: { path: 'membership_blocked' },
    membership_unpaid: { path: 'membership_unpaid' },
    trenord_loyalty: { path: 'trenord_loyalty' },
  }),
};

export const TaskAIRoute: MainNavRoute = {
  path: '/task_ai',
  label: 'routes.task_ai',
  type: 1,
  permissions: [PERMISSIONS.TASKS__AI_VIEW],
};
